import axios from 'axios';

const api = axios.create({
  baseURL: 'https://augeapp-homol.shop/api',
})

const localApi = axios.create({
  baseURL: 'http://localhost:8000'
})

const viaCep = axios.create({
  baseURL: 'https://viacep.com.br/ws/',
})

const autoLoginUrl = 'https://augeapp-homol.shop/vendedor/login';

api.defaults.headers.common['Api-Authorization'] = 'Bearer $2y$10$XpgV9iIs63EuXQ8u6W/2seqmHU3GTRRLWWWNc08JvkzY2sJs2L3I.';

export { api, localApi, viaCep, autoLoginUrl };
